module.exports = __webpack_public_path__ + "static/media/pixi-download.02c68f4b.svg";